{
  "name": "CargoPaymentUI",
  "version": "0.0.0",
  "engines": {
    "node": "^22.22.3 || ^24.21.0 || >=26.0.0",
    "npm": ">=10.9.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=development --hmr",
    "start-mock": "ng serve --configuration=mock --hmr",
    "build": "ng build",
    "docker-build": "node docker-builder.js",
    "docker-run": "node docker-runner.js ",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --code-coverage",
    "lint": "ng lint",
    "refreshVSToken": "vsts-npm-auth -config .npmrc",
    "format": "prettier --config .prettierrc **/*.{ts,html,scss} --check",
    "e2es": "playwright test -c ./e2e/playwright.config.ts --headed",
    "e2es-headless": "playwright test -c ./e2e/playwright.config.ts"
  },
  "private": true,
  "dependencies": {
    "@alaska-its/alaska-accordion": "^1.1.0",
    "@alaska-its/alaska-button": "^1.1.0",
    "@alaska-its/alaska-checkbox": "^1.0.0",
    "@alaska-its/alaska-dropdown": "^1.0.0",
    "@alaska-its/alaska-input": "^1.0.0",
    "@alaska-its/alaska-searchbar": "^1.0.0",
    "@alaska-its/design-tokens": "^1.0.0",
    "@alaskaairux/webcorestylesheets": "^3.7.3",
    "@angular/animations": "~22.2.2",
    "@angular/common": "~22.2.2",
    "@angular/compiler": "~22.2.2",
    "@angular/core": "~22.2.2",
    "@angular/forms": "~22.2.2",
    "@angular/platform-browser": "~22.2.2",
    "@angular/platform-browser-dynamic": "~22.2.2",
    "@angular/router": "~22.2.2",
    "@aurodesignsystem/auro-alert": "^5.0.0",
    "@aurodesignsystem/webcorestylesheets": "^10.1.4",
    "@microsoft/applicationinsights-web": "^2.7.4",
    "@microsoft/signalr": "^7.0.0",
    "@webcomponents/webcomponentsjs": "^2.7.0",
    "angular-oauth2-oidc": "~22.0.2",
    "bluefin-shieldconex": "^3.1.0",
    "focus-visible": "^5.2.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~22.2.2",
    "@angular/cli": "~22.2.2",
    "@angular/compiler-cli": "~22.2.2",
    "@eslint/js": "~9.39.0",
    "@playwright/test": "^1.22.2",
    "@types/jasmine": "~5.1.9",
    "@types/node": "~22.18.8",
    "angular-eslint": "~22.5.0",
    "dotenv": "^16.0.0",
    "eslint": "~9.39.0",
    "eslint-config-prettier": "~10.1.8",
    "inquirer": "^8.2.2",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.12.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-htmlfile-reporter": "^0.3.8",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "prettier": "^2.6.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "~8.71.1"
  }
}
